import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { FC, useMemo } from 'react'

import { getDetailSezRegions } from '@/services/sez-regions'
import { BaseRequest } from '@/types/sez-regions'
import { useAppSelector } from '@/utils/hooks'
import { titleSez } from '@/utils/string'

const MainInfo: FC<{ setHitContact: React.Dispatch<React.SetStateAction<boolean>> }> = ({ setHitContact }) => {
  const { t } = useTranslation()
  const router = useRouter()

  const request: BaseRequest = useMemo(() => {
    return {
      params: { slug: String(router.query?.slug) },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data } = useAppSelector(getDetailSezRegions.select(request))
  return (
    <div className='container mt-6 flex w-full flex-col justify-between gap-6 lg:flex-row lg:items-end lg:gap-3.5'>
      <div className='flex flex-1 flex-col gap-4 lg:gap-3'>
        <h5 className='text-xl font-bold lg:text-2xl'>
          {titleSez(String(data?.data.title), String(router.locale), false)}
        </h5>

        <div className='flex flex-col gap-2 lg:flex-row lg:items-center lg:gap-[15px]'>
          <div className='flex items-center gap-2'>
            <span className='kek-briefcase text-xl text-red' />
            <span className='text-sm tracking-[-0.084px] text-gray-1'>{data?.data.category}</span>
          </div>
          <div className='flex items-center gap-2'>
            <span className='kek-location text-xl text-red' />
            <span className='text-sm tracking-[-0.084px] text-gray-1'>{data?.data.address}</span>
          </div>
        </div>
      </div>

      <button
        className='flex w-full shrink-0 items-center justify-center gap-2 rounded-full bg-red px-5 py-3 lg:w-fit'
        onClick={() => setHitContact(true)}
      >
        <span className='kek-call text-xl text-white' />
        <span className='font-bold text-white'>{t('common:contactNow')}</span>
      </button>
    </div>
  )
}

export default MainInfo
